/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IObrienSimpleDivData } from './obrien-simple-div.data';
import { IObrienSimpleDivProps } from './obrien-simple-div.props.autogenerated';

export interface IObrienSimpleDivViewProps extends IObrienSimpleDivProps<IObrienSimpleDivData> {
    obClassName: string;
    obID: string;
}

/**
 *
 * ObrienSimpleDiv component
 * @extends {React.PureComponent<IObrienSimpleDivProps<IObrienSimpleDivData>>}
 */
class ObrienSimpleDiv extends React.PureComponent<IObrienSimpleDivProps<IObrienSimpleDivData>> {
    public render(): JSX.Element | null {

        const { config } = this.props;

        const ObClassName = config.obClassName ? config.obClassName : '';
        const ObId = config.obID ? config.obID : '';
        const ObrienSimpleDivViewProps = {
            ...this.props,
            obClassName: ObClassName,
            obID: ObId
        };

        return this.props.renderView(ObrienSimpleDivViewProps);
    }
}

export default ObrienSimpleDiv;
